// ANCHOR React
import React from 'react';

// ANCHOR Base
import { styled } from 'baseui';

// ANCHOR Styles
import { BADGE_CONTAINER } from './styles';

const BadgeContainer = styled('div', BADGE_CONTAINER);

interface IProps {
  children: React.ReactNode;
}

export const ImageBadgeContainer = ({ children }: IProps) => (
  <BadgeContainer>
    {children}
  </BadgeContainer>
);
